module.exports = __webpack_public_path__ + "assets/img/intro-normal-3.f74f2272.jpg";